import Box from '@mui/material/Box';
import { Stepper as MuiStepper, Step as MuiStep, StepLabel as MuiStepLabel } from '@mui/material';
import { styled } from '@mui/material/styles';
import { NavigationStepper as NavigationStepperType } from '@/schemas/sceneDataSchema';
import { getRouteStep } from '@/services/location-service';

const getInitialStep = (steps: NavigationStepperType['steps']): number => {
  const { step_id } = getRouteStep();
  const stepIndex = steps.findIndex((step) => step.step_name === step_id);
  return stepIndex !== -1 ? stepIndex : 0;
};

const StyledStepLabel = styled(MuiStepLabel)({
  '& .MuiStepLabel-label': {
    fontSize: '0.9375rem',
    fontWeight: 600,
    lineHeight: 1.334,
  },
});

export const NavigationStepper = ({ component }: { component: NavigationStepperType }) => {
  const activeStep = getInitialStep(component.steps);

  return (
    <Box sx={{ width: '100%' }}>
      <MuiStepper activeStep={activeStep}>
        {component.steps.map((step) => (
          <MuiStep key={step.step_name}>
            <StyledStepLabel>{String(step.label)}</StyledStepLabel>
          </MuiStep>
        ))}
      </MuiStepper>
    </Box>
  );
};
